module.exports = __webpack_public_path__ + "img/buy-shansuan.2368a61c.jpg";